module.exports = __webpack_public_path__ + "static/media/champion02.f281e81b.jpg";